if (!customElements.get('shopde-mobile-product-share')) {
  customElements.define(
    'shopde-mobile-product-share',
    class extends HTMLElement {
      connectedCallback() {
        this.trigger = this.querySelector('.shopde-mobile-product-share__trigger');
        this.dialog = this.querySelector('dialog');
        this.closeButton = this.querySelector('[data-share-close]');
        this.copyButton = this.querySelector('[data-share-copy]');
        this.nativeButton = this.querySelector('[data-share-native]');
        this.fallback = this.querySelector('[data-share-fallback]');
        this.urlInput = this.querySelector('input');
        this.status = this.querySelector('[role="status"]');
        if (!this.trigger || !this.dialog || !this.closeButton || !this.copyButton || !this.nativeButton || !this.fallback || !this.urlInput || !this.status) return;
        try {
          const url = new URL(this.dataset.shareUrl, window.location.origin);
          if (url.origin !== window.location.origin || !['https:', 'http:'].includes(url.protocol)) return;
          url.search = '';
          url.hash = '';
          this.shareData = { title: this.dataset.shareTitle, text: this.dataset.shareTitle, url: url.href };
          this.urlInput.value = url.href;
          const message = `${this.shareData.title}\n${url.href}`;
          const whatsapp = new URL('https://wa.me/');
          whatsapp.searchParams.set('text', message);
          this.querySelector('[data-share-whatsapp]').href = whatsapp.href;
          this.querySelector('[data-share-email]').href = `mailto:?subject=${encodeURIComponent(this.shareData.title)}&body=${encodeURIComponent(message)}`;
        } catch {
          return;
        }

        this.operation = (this.operation || 0) + 1;
        this.lifecycle = new AbortController();
        const listen = (target, event, handler) => target.addEventListener(event, handler, { signal: this.lifecycle.signal });
        this.mobile = window.matchMedia('(max-width: 989px)');
        listen(this.trigger, 'click', () => this.open());
        listen(this.closeButton, 'click', () => this.close());
        listen(this.dialog, 'close', () => { if (!this.dialog.open) this.finishClose(); });
        listen(this.dialog, 'cancel', event => { event.preventDefault(); this.close(); });
        listen(this.dialog, 'click', event => {
          if (event.target !== this.dialog) return;
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.close();
        });
        listen(this.copyButton, 'click', () => this.copy());
        listen(this.nativeButton, 'click', () => this.shareNative());
        listen(this.urlInput, 'click', () => this.selectUrl());
        listen(this.mobile, 'change', () => { if (!this.mobile.matches) this.close(false); });
      }

      disconnectedCallback() {
        this.close(false);
        this.lifecycle?.abort();
      }

      open() {
        if (!this.mobile.matches || this.dialog.open || !this.shareData) return;
        this.status.textContent = '';
        this.fallback.hidden = true;
        try {
          this.dialog.showModal();
        } catch {
          return;
        }
        this.dialog.scrollTop = 0;
        this.opened = true;
        this.operation++;
        this.previousOverflow = [document.body.style.getPropertyValue('overflow'), document.body.style.getPropertyPriority('overflow')];
        document.body.style.setProperty('overflow', 'hidden');
        this.trigger.setAttribute('aria-expanded', 'true');
        this.closeButton.focus({ preventScroll: true });
      }

      close(restoreFocus = true) {
        if (this.dialog?.open) this.dialog.close();
        this.finishClose(restoreFocus);
      }

      finishClose(restoreFocus = true) {
        if (!this.opened) return;
        this.opened = false;
        this.operation++;
        this.nativePending = false;
        this.copyButton.disabled = false;
        this.nativeButton.disabled = false;
        if (this.previousOverflow[0]) document.body.style.setProperty('overflow', ...this.previousOverflow);
        else document.body.style.removeProperty('overflow');
        this.trigger.setAttribute('aria-expanded', 'false');
        if (restoreFocus && this.isConnected && this.mobile.matches && this.trigger.getClientRects().length) this.trigger.focus({ preventScroll: true });
      }

      revealUrl(message) {
        this.fallback.hidden = false;
        this.status.textContent = message;
        this.dialog.scrollTop = this.dialog.scrollHeight;
        this.selectUrl();
      }

      async shareNative() {
        if (!this.dialog.open || this.nativePending) return;
        this.status.textContent = '';
        const operation = this.operation;
        this.nativePending = true;
        this.nativeButton.disabled = true;
        try {
          if (!navigator.share || (navigator.canShare && !navigator.canShare(this.shareData))) {
            this.revealUrl(this.dataset.shareUnavailable);
            return;
          }
          await navigator.share(this.shareData);
          if (operation === this.operation) this.close();
        } catch (error) {
          if (operation === this.operation && error?.name !== 'AbortError') this.revealUrl(this.dataset.shareUnavailable);
        } finally {
          if (operation === this.operation) {
            this.nativePending = false;
            this.nativeButton.disabled = false;
          }
        }
      }

      async copy() {
        if (!this.dialog.open || this.copyButton.disabled) return;
        this.status.textContent = '';
        const operation = this.operation;
        this.copyButton.disabled = true;
        try {
          if (!navigator.clipboard?.writeText) {
            this.revealUrl(this.dataset.shareManual);
            return;
          }
          await navigator.clipboard.writeText(this.shareData.url);
          if (operation === this.operation) this.status.textContent = this.dataset.shareSuccess;
        } catch {
          if (operation === this.operation) this.revealUrl(this.dataset.shareManual);
        } finally {
          if (operation === this.operation) this.copyButton.disabled = false;
        }
      }

      selectUrl() {
        this.urlInput.focus({ preventScroll: true });
        this.urlInput.select();
      }
    }
  );
}
